import { render, staticRenderFns } from "./ordersDeliveryPrintDetailCompactTable.vue?vue&type=template&id=5dbd19f5&"
import script from "./ordersDeliveryPrintDetailCompactTable.vue?vue&type=script&lang=ts&"
export * from "./ordersDeliveryPrintDetailCompactTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports